import { SortElement } from "../shared/list";


export const converSortToStrings = <T>(sort: SortElement<T>[]) => {
  return sort.map((s) => {
    return [s.key, s.type as string].join(',');
  });
};

export const convertStringsToSort = <T>(sort: string[]): SortElement<T>[] => {
  return sort.map((s) => {
    const parts = s.split(',');
    return { key: parts[0], type: parts[1] as any };
  });
};
